export default "__VITE_ASSET__CgTjHiqe__"